import { ModelTypes, NoliboxModelTypes, NOLIBOX_MODEL_TYPES } from "@/modules/editor/constant";

export const isNoliboxModel = (modelType: ModelTypes): modelType is NoliboxModelTypes => {
  return NOLIBOX_MODEL_TYPES.some((type) => type === modelType);
};
